import SettingsBenchmarking from './SettingsBenchmarking';

export default SettingsBenchmarking;
